import { AfterContentInit, ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
    ListingAmenitiesAmenityBundleByAssetGQL,
    ListingAmenitiesAmenityBundleByAssetQuery, ListingHotelQuery,
    ListingPropertyQuery
} from '../../../../../../../graphql'
import { UnsubscribeOnDestroy } from '../../../../../../utility'

@Component({
    selector: 'app-listing-amenities',
    styleUrls: ['listing-amenities.scss'],
    templateUrl: 'listing-amenities.html'
})
export class ListingAmenitiesComponent extends UnsubscribeOnDestroy implements AfterContentInit{
    @Input() assetId: string
    @Input() amenities: ListingPropertyQuery['property']['amenities'] | ListingHotelQuery['hotelListing']['amenities']

    sections: ListingAmenitiesAmenityBundleByAssetQuery['amenityBundleByAsset']['sections']

    // Constructor
    constructor(private _activatedRoute: ActivatedRoute,
                private _router: Router,
                private _fetchAmenityBundleGQL: ListingAmenitiesAmenityBundleByAssetGQL) {
        super()
    }

    ngAfterContentInit(): void {
        this._subscriptions.push(this._fetchAmenityBundleGQL
            .watch({ assetId: this.assetId }, { fetchPolicy: 'no-cache' })
            .valueChanges.subscribe(result => {
                if (!result.loading) {
                    const bundle = result.data?.amenityBundleByAsset
                    this.sections = bundle.sections.filter(section => {
                        let amenityIds = section.amenities.map(amenity => amenity.amenityId)
                        let intersection = amenityIds.filter(amenityId => this.amenities.amenityIds?.includes(amenityId));
                        return !!intersection?.length
                    })
                }
            }))
    }

    // Public
    isVisible(amenityId: string) {
        return this.amenities.amenityIds?.includes(amenityId)
    }
}
